import React, { useState, useRef, useEffect, useCallback } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Card, Avatar, FormControl, useMediaQuery, Collapse, Checkbox, FormControlLabel, Divider } from "@mui/material";
import { api } from "common";
import { useTranslation } from "react-i18next";
import CircularLoading from "components/CircularLoading";
import { makeStyles } from "@mui/styles";
import { WEB_MAIN_COLOR, WEB_SECONDORY_COLOR, FONT_FAMILY } from "../common/sharedFunctions";
import { useParams,useLocation } from "react-router-dom";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AlertDialog from "../components/AlertDialog";
import { colors } from "components/Theme/WebTheme";
import GoBackButton from "components/GoBackButton";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const useStyles = makeStyles((theme) => ({
    typography: {
        fontFamily: FONT_FAMILY,
      },
    textField: props => ({
        "& label.Mui-focused": {
            color: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    }),
    rootRtl: props => ({
        "& label": {
            right: 10,
            left: "auto",
            paddingRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& label.Mui-focused": {
            color: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    }),
    rootRtl_3: props => ({
        "& label": {
            right: 0,
            left: "auto",
            paddingRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& label.Mui-focused": {
            color: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    }),
    rootRtl_2: props => ({
        "& label": {
            right: 5,
            left: "auto",
            paddingRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& label.Mui-focused": {
            color: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    }),
    rootRtl_1: props => ({
        "& label": {
            right: 10,
            left: "auto",
            paddingRight: 20,
            fontFamily: FONT_FAMILY,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 15,
            fontFamily: FONT_FAMILY,
        },
        "& label.Mui-focused": {
            color: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
            },
        },
        "& input": {
            fontFamily: FONT_FAMILY,
          },
    }),
    selectField_rtl: props => ({
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
        "& label": {
            right: 0,
            left: "auto",
            fontFamily: FONT_FAMILY,

        },
        "& legend": {
            textAlign: "right",
            marginRight: 35,
            fontFamily: FONT_FAMILY,
        },
    }),
    right: {
        textAlign: "right", right: 0, left: "auto", paddingRight: 40, fontFamily: FONT_FAMILY,
    },
    right_1: {
        textAlign: "right", right: 0, left: "auto", paddingRight: 45, fontFamily: FONT_FAMILY,
    },
    selectField: props => ({
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        },
    }),
}));

function EditUser() {
    const { id, usertype } = useParams();
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const staticusers = useSelector((state) => state.usersdata.staticusers);
    const settings = useSelector((state) => state.settingsdata.settings);
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loaded = useRef(false);
    const fileInputRef = useRef();
    const { editUser, fetchUsersOnce, updateCustomerProfileImage, checkUserExists, addUser, consultarCPF } = api;
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
    //const [data, setData] = useState(null);
    const [oldData, setOldData] = useState(null);
    const [profileImage, setProfileImage] = useState(null);
    const [loading, setLoading] = useState(false);
    // 'idle' | 'loading' | 'filled' | 'not_configured' | 'limit_exceeded' | 'error'
    const [docStatus, setDocStatus] = useState('idle');
    const [docType, setDocType] = useState(null); // 'CPF' | 'CNPJ' | null
    const integrationDetails = useSelector((state) => state.integrationdata.integrationDetails);
    const classes = useStyles();
    const [fleetAdmins, setFleetAdmins] = useState([]);
    const [fleetAdminsObj, setFleetAdminsObj] = useState("");
    const [approved, setApproved] = useState(false);
    const isMidScreen = useMediaQuery('(max-width:1199px)');
    const [signUpReferraldata,setsignupReferralData]= useState("")
    const {state}=useLocation();
    const MAIN_COLOR = WEB_MAIN_COLOR(settings?.appCat);
    const SECONDORY_COLOR = WEB_SECONDORY_COLOR(settings?.appCat);
    const [showAddress, setShowAddress] = useState(false);
    const [cepStatus, setCepStatus] = useState('idle');
    const emptyAddress = { cep: '', endereco: '', numero: '', semNumero: false, complemento: '', bairro: '', cidade: '', uf: '', referencia: '' };
    const [data, setData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        birthDate: '',
        gender: '',
        cpfCnpj: '',
        rg: '',
        nomeMae: '',
        approved: false,
        verifyId: '',
        address: { ...emptyAddress }
    });
    

    useEffect(() => {
        dispatch(fetchUsersOnce());
    }, [dispatch, fetchUsersOnce]);

    useEffect(() => {
        if (id && usertype) {
            if (staticusers) {
                const user = staticusers.filter(
                    (user) => user.id === id.toString() && user.usertype === usertype.toString()
                )[0];
                const refferedUser = staticusers.filter(
                    (value) =>value.id === user?.signupViaReferral
                )
                if(refferedUser.length>0){
                    const refferedData= `${refferedUser[0].firstName} ${refferedUser[0].lastName} (${refferedUser[0].mobile} ) ${refferedUser[0].email}` 
                    setsignupReferralData(refferedData)
                }
                if (!user) {
                    navigate("/404");
                }
                
                // ADICIONE ESTA PARTE - Formata CPF/CNPJ
                let cpfCnpjValue = '';
                if (user.document?.value) {
                    cpfCnpjValue = api.formatCpfCnpj ? 
                        api.formatCpfCnpj(user.document.value) : 
                        user.document.value;
                }
                
                const userAddress = user.address || null;
                if (userAddress) setShowAddress(true);

                setData({
                    ...user,
                    birthDate: user.birthDate || '',
                    gender: user.gender || '',
                    cpfCnpj: cpfCnpjValue,
                    rg: user.rg || '',
                    nomeMae: user.nomeMae || '',
                    address: userAddress ? { ...emptyAddress, ...userAddress } : { ...emptyAddress }
                });

                setOldData({
                    ...user,
                    birthDate: user.birthDate || '',
                    gender: user.gender || '',
                    cpfCnpj: cpfCnpjValue,
                    rg: user.rg || '',
                    nomeMae: user.nomeMae || '',
                    address: userAddress ? { ...emptyAddress, ...userAddress } : { ...emptyAddress }
                });
            }
        } else {
            // EM VEZ DE setData([]), INICIALIZE COM OS CAMPOS VAZIOS
            setData({
                firstName: '',
                lastName: '',
                email: '',
                mobile: '',
                birthDate: '',
                gender: '',
                cpfCnpj: '',
                rg: '',
                nomeMae: '',
                approved: false,
                verifyId: ''
            });
            setOldData(null); // Não há dados antigos para novo usuário
        }
        loaded.current = true;
    }, [staticusers, id, navigate, usertype]);

    useEffect(() => {
        if (staticusers) {
            if (auth && auth.profile && auth.profile.usertype === "admin") {
                let arr = staticusers.filter((user) => user.usertype === "fleetadmin");
                let obj = {};
                let arr2 = [];
                for (let i = 0; i < arr.length; i++) {
                    let user = arr[i];
                    arr2.push({
                        id: user.id,
                        desc:
                            user.firstName +
                            " " +
                            user.lastName +
                            " (" +
                            (settings.AllowCriticalEditsAdmin
                                ? user.mobile
                                : t("hidden_demo")) +
                            ") " +
                            (settings.AllowCriticalEditsAdmin
                                ? user.email
                                : t("hidden_demo")),
                    });
                    obj[user.id] =
                        user.firstName +
                        " " +
                        user.lastName +
                        " (" +
                        (settings.AllowCriticalEditsAdmin
                            ? user.mobile
                            : t("hidden_demo")) +
                        ") " +
                        (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo"));
                }
                setFleetAdmins(arr2);
                setFleetAdminsObj(obj);
            }
        }
    }, [
        staticusers,
        auth.profile.usertype,
        auth.profile.uid,
        settings.AllowCriticalEditsAdmin,
        auth,
        t
    ]);

    const profileImageChange = async (e) => {
        setProfileImage(e.target.files[0]);
    };

    const handleCommonAlertClose = (e) => {
        e.preventDefault();
        setCommonAlert({ open: false, msg: "" });
    };

    const handleCpfCnpjChange = (e) => {
        const { value } = e.target;
        const formattedValue = api.formatCpfCnpj ? api.formatCpfCnpj(value) : value;
        const digits = value.replace(/\D/g, '');
        setDocType(digits.length === 11 ? 'CPF' : digits.length === 14 ? 'CNPJ' : null);
        setDocStatus('idle');
        setData({ ...data, cpfCnpj: formattedValue });
    };

    const toTitleCase = (str) =>
        str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

    // "30/11/1899" → "1899-11-30"
    const parseNasc = (nasc) => {
        if (!nasc) return '';
        const [d, m, y] = nasc.split('/');
        if (!d || !m || !y) return '';
        return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
    };

    const mapSexo = (sexo) => {
        if (!sexo) return '';
        const s = sexo.toLowerCase();
        if (s.includes('fem')) return 'female';
        if (s.includes('masc')) return 'male';
        return 'na';
    };

    const handleCpfCnpjBlur = useCallback(async (e) => {
        const digits = e.target.value.replace(/\D/g, '');

        if (digits.length === 14) { setDocType('CNPJ'); return; }
        if (digits.length !== 11) return;

        setDocType('CPF');

        // Verifica se a integração está configurada antes de chamar
        const cpfConfig = integrationDetails?.cpf;
        if (!cpfConfig?.enabled || !cpfConfig?.token) {
            setDocStatus('not_configured');
            return;
        }

        setDocStatus('loading');

        try {
            const result = await consultarCPF(digits, integrationDetails, auth?.profile?.uid);

            console.log('[CPF Lookup] result:', result);

            if (result?.limitExceeded) {
                setDocStatus('limit_exceeded');
                return;
            }

            if (result?.data?.NOME) {
                const parts = result.data.NOME.trim().split(' ');
                const first = toTitleCase(parts[0] || '');
                const last  = toTitleCase(parts.slice(1).join(' '));
                setData((prev) => ({
                    ...prev,
                    firstName:  first || prev.firstName,
                    lastName:   last  || prev.lastName,
                    birthDate:  parseNasc(result.data.NASC) || prev.birthDate,
                    gender:     mapSexo(result.data.SEXO)   || prev.gender,
                    nomeMae:    toTitleCase(result.data.NOME_MAE || '') || prev.nomeMae,
                }));
                setDocStatus('filled');
            } else {
                console.warn('[CPF Lookup] sem dados:', result);
                setDocStatus('error');
            }
        } catch (err) {
            console.error('[CPF Lookup] erro:', err);
            setDocStatus('error');
        }
    }, [consultarCPF, integrationDetails, auth?.profile?.uid]);

    const handleInputChange = (e) => {
        setData({ ...data, [e.target.id]: e.target.value });
    };

    const handleChangeApproved = (event) => {
        setApproved(event.target.value);
        setData({ ...data, approved: event.target.value });
    };

    const getKeyByValue = (object, value) => {
        return Object.keys(object).find((key) => object[key] === value);
    };

    const handleChangeFleetAdmin = (event) => {
        setData({
            ...data,
            fleetadmin: getKeyByValue(fleetAdminsObj, event.target.value),
        });
    };

    const handleAddressChange = (e) => {
        setData(prev => ({ ...prev, address: { ...prev.address, [e.target.id]: e.target.value } }));
    };

    const handleSemNumeroChange = (e) => {
        setData(prev => ({ ...prev, address: { ...prev.address, semNumero: e.target.checked, numero: e.target.checked ? '' : prev.address.numero } }));
    };

    const handleCepChange = async (e) => {
        const raw = e.target.value.replace(/\D/g, '').slice(0, 8);
        const formatted = raw.length > 5 ? raw.slice(0, 5) + '-' + raw.slice(5) : raw;
        setData(prev => ({ ...prev, address: { ...prev.address, cep: formatted } }));
        if (raw.length !== 8) { setCepStatus('idle'); return; }
        setCepStatus('loading');
        try {
            const res = await fetch(`https://viacep.com.br/ws/${raw}/json/`);
            const json = await res.json();
            if (json.erro) { setCepStatus('error'); return; }
            setData(prev => ({
                ...prev,
                address: {
                    ...prev.address,
                    cep: formatted,
                    endereco: json.logradouro || prev.address.endereco,
                    bairro:   json.bairro    || prev.address.bairro,
                    cidade:   json.localidade|| prev.address.cidade,
                    uf:       json.uf        || prev.address.uf,
                }
            }));
            setCepStatus('filled');
        } catch { setCepStatus('error'); }
    };
    const navigateToInfo = () => {
        setTimeout(() => {
            setProfileImage(null);
            if (usertype === "customer") {
                navigate("/users/0",{state:{pageNo:state?.pageNo}});
            } else if (usertype === "driver") {
                navigate("/users/1",{state:{pageNo:state?.pageNo}});
            } else if (usertype === "fleetadmin") {
                navigate("/users/2",{state:{pageNo:state?.pageNo}});
            } else if (usertype === "admin") {
                navigate("/users/3",{state:{pageNo:state?.pageNo}});
            }
            setLoading(false);
        }, 1000);
    }

    const handleUpdate = () => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (data.cpfCnpj && data.cpfCnpj.replace(/\D/g, '').length > 0) {
            const isValid = api.validateCpfCnpj ? 
                api.validateCpfCnpj(data.cpfCnpj) : 
                true;
            
            if (!isValid) {
                setCommonAlert({ open: true, msg: t('cpf_cnpj_invalid') || 'CPF/CNPJ inválido' });
                return;
            }
        }

        if (!(data.lastName && data.firstName)) {
            setCommonAlert({ open: true, msg: t("proper_input_name") });
        } else if (!re.test(data.email)) {
            setCommonAlert({ open: true, msg: t("proper_email") });
        } else if (!data.mobile) {
            setCommonAlert({ open: true, msg: t("proper_mobile") });
        } else {
            if (settings.AllowCriticalEditsAdmin) {
                setLoading(true);

                // Preparar os dados para envio
                const documentNumbers = data.cpfCnpj ? data.cpfCnpj.replace(/\D/g, '') : '';

                // Verificar CPF duplicado contra usuários já carregados (sem chamada de rede)
                const newCpfDigits = documentNumbers;
                const oldCpfDigits = oldData?.document?.value || '';
                if (newCpfDigits && newCpfDigits !== oldCpfDigits) {
                    const cpfConflict = staticusers?.find(
                        u => u.document?.value === newCpfDigits && u.id !== data.id
                    );
                    if (cpfConflict) {
                        setCommonAlert({ open: true, msg: t("cpf_already_exists") || "Este CPF/CNPJ já está cadastrado em outra conta." });
                        setLoading(false);
                        return;
                    }
                }
                
                // Remover cpfCnpj e quaisquer campos desnecessários
                const { cpfCnpj, document, ...cleanedData } = data;
                
                const hasAddressData = data.address && Object.entries(data.address).some(([k, v]) => k !== 'semNumero' && v);
                const userDataToUpdate = {
                    ...cleanedData,
                    birthDate: data.birthDate || null,
                    gender: data.gender || '',
                    document: documentNumbers ? {
                        value: documentNumbers,
                        type: documentNumbers.length === 11 ? 'CPF' :
                            documentNumbers.length === 14 ? 'CNPJ' : ''
                    } : null,
                    rg: data.rg || '',
                    nomeMae: data.nomeMae || '',
                    address: hasAddressData ? data.address : null,
                };

                if (profileImage) {
                    updateCustomerProfileImage(profileImage, data.id).then(() => {
                        dispatch(fetchUsersOnce());
                        navigateToInfo();
                    });
                }
                
                const hasDataChanged =
                    data.firstName !== oldData.firstName ||
                    data.lastName !== oldData.lastName ||
                    data.email !== oldData.email ||
                    data.mobile !== oldData.mobile ||
                    data.birthDate !== oldData.birthDate ||
                    data.gender !== oldData.gender ||
                    data.rg !== oldData.rg ||
                    data.nomeMae !== oldData.nomeMae ||
                    (data.cpfCnpj && data.cpfCnpj.replace(/\D/g, '') !== (oldData.document?.value || '')) ||
                    JSON.stringify(data.address) !== JSON.stringify(oldData.address);

                if (hasDataChanged || profileImage) {
                    console.log("Enviando para update:", userDataToUpdate);
                    dispatch(editUser(data.id, userDataToUpdate));
                    dispatch(fetchUsersOnce());
                    navigateToInfo();
                } else {
                    setCommonAlert({ open: true, msg: t("make_changes_to_update") });
                    setLoading(false);
                }

            } else {
                setCommonAlert({ open: true, msg: t('demo_mode') });
            }
            loaded.current = true;
        }
    };

    const handleAdd = () => {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (data.cpfCnpj && data.cpfCnpj.replace(/\D/g, '').length > 0) {
            const isValid = api.validateCpfCnpj ? 
                api.validateCpfCnpj(data.cpfCnpj) : 
                true;
            
            if (!isValid) {
                setCommonAlert({ open: true, msg: t('cpf_cnpj_invalid') || 'CPF/CNPJ inválido' });
                return;
            }
        }

        if (!(data.lastName && data.firstName)) {
            setCommonAlert({ open: true, msg: t("proper_input_name") });
        } else if (!re.test(data.email)) {
            setCommonAlert({ open: true, msg: t("proper_email") });
        } else if (!data.mobile) {
            setCommonAlert({ open: true, msg: t("proper_mobile") });
        } else {
            new Promise((resolve, reject) => {
                setLoading(true);
                setTimeout(() => {
                    // Verificar CPF duplicado contra usuários já carregados (sem chamada de rede)
                    const addDocDigits = data.cpfCnpj ? data.cpfCnpj.replace(/\D/g, '') : '';
                    if (addDocDigits) {
                        const cpfConflict = staticusers?.find(u => u.document?.value === addDocDigits);
                        if (cpfConflict) {
                            setCommonAlert({ open: true, msg: t("cpf_already_exists") || "Este CPF/CNPJ já está cadastrado em outra conta." });
                            reject(new Error("CPF already exists"));
                            return;
                        }
                    }

                    // Verificar email/mobile duplicado via backend
                    const checkData = {
                        email: data.email,
                        mobile: data.mobile,
                    };

                    checkUserExists(checkData).then((res) => {
                        if (res.users && res.users.length > 0) {
                            setCommonAlert({ open: true, msg: t("user_exists") });
                            reject(new Error("User already exists"));
                        } else if (res.error) {
                            setCommonAlert({ open: true, msg: t("email_or_mobile_issue") });
                            reject(new Error("Email or Mobile issue"));
                        } else {
                            const c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                            const reference = [...Array(5)]
                                .map((_) => c[~~(Math.random() * c.length)])
                                .join("");
                            
                            // Preparar os dados completos para adicionar
                            const documentNumbers = data.cpfCnpj ? data.cpfCnpj.replace(/\D/g, '') : '';
                            
                            // Remover cpfCnpj antes de espalhar
                            const { cpfCnpj, document, ...cleanedData } = data;
                            
                            const hasAddressDataAdd = data.address && Object.entries(data.address).some(([k, v]) => k !== 'semNumero' && v);
                            const userDataToAdd = {
                                ...cleanedData,
                                birthDate: data.birthDate || null,
                                gender: data.gender || '',
                                document: documentNumbers ? {
                                    value: documentNumbers,
                                    type: documentNumbers.length === 11 ? 'CPF' :
                                        documentNumbers.length === 14 ? 'CNPJ' : ''
                                } : null,
                                rg: data.rg || '',
                                nomeMae: data.nomeMae || '',
                                address: hasAddressDataAdd ? data.address : null,
                                createdAt: new Date().getTime(),
                                approved: approved,
                                walletBalance: 0
                            };

                            let role = auth.profile.usertype;
                            
                            if(usertype === "customer"){
                                userDataToAdd["usertype"] = "customer";
                                userDataToAdd["referralId"] = reference;
                                if (role === "fleetadmin") {
                                    userDataToAdd["fleetadmin"] = auth.profile.uid;
                                }
                                resolve();
                            } else if(usertype === "driver"){
                                userDataToAdd["driverActiveStatus"] = false;
                                userDataToAdd["usertype"] = "driver";
                                userDataToAdd["referralId"] = reference;
                                userDataToAdd["queue"] = false;
                                if (role === "fleetadmin") {
                                    userDataToAdd["fleetadmin"] = auth.profile.uid;
                                }
                                if(approved === true){
                                    userDataToAdd['adminApprovedTrue'] = true;
                                } else {
                                    userDataToAdd['adminApprovedTrue'] = false;
                                }
                                resolve();
                            } else if(usertype === "fleetadmin") {
                                userDataToAdd["usertype"] = "fleetadmin";
                                resolve();
                            } else if(usertype === "admin"){
                                userDataToAdd["usertype"] = usertype.toString();
                                userDataToAdd["approved"] = true;
                                resolve();
                            } else {
                                reject(new Error("Invalid usertype Add"));
                                setCommonAlert({ open: true, msg: t("invalid_userType_add") });
                            }
                            
                            console.log("Enviando para add:", userDataToAdd);
                            dispatch(addUser(userDataToAdd));
                            dispatch(fetchUsersOnce());
                            handleBackNavigation();
                        }
                    });
                });
            }).catch((e) => {
                console.error("caught an error:", e);
            }).finally(() => {
                setLoading(false);
            });
        }
    };

    const handleBackNavigation = ()=>{
        if(usertype === "customer"){
            navigate("/users/0");
        }else if(usertype === "driver"){
            navigate("/users/1");
        }else if (usertype === "fleetadmin"){
            navigate("/users/2");
        }else if(usertype === "admin"){
            navigate("/users/3");
        }
    }

    const isDriverOrFleetAdmin = usertype === "driver" || usertype === "fleetadmin";
    const isNotAdmin = auth.profile.usertype === 'fleetadmin' || auth.profile.usertype === 'driver';

    return loading ? (
        <CircularLoading />
    ) : (
        <div>
            <Card
                style={{
                    borderRadius: "19px",
                    backgroundColor: colors.WHITE,
                    minHeight: 100,
                    maxWidth: "75vw",
                    marginTop: 20,
                    marginBottom: 20,
                    padding: 20,
                    boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
                }}
            >
                <Typography
                    variant="h5"
                    style={{
                        margin: "10px 10px 0 5px",
                        textAlign: isRTL === "rtl" ? "right" : "left",
                        fontFamily: FONT_FAMILY,
                    }}
                >
                    {id ?
                        (
                            (usertype === "customer" && t("update_customer_title")) || (usertype === "driver" && t("update_driver_title")) || (usertype === "fleetadmin" && t("update_fleetAdmin_title")) || (usertype === "admin" && t("update_admin_title"))
                        )
                        :
                        (
                            (usertype === "customer" && t("add_customer_title")) || (usertype === "driver" && t("add_driver_title")) || (usertype === "fleetadmin" && t("add_fleetadmin_title")) || (usertype === "admin" && t("add_admin_title"))
                        )
                    }
                </Typography>
                <GoBackButton isRTL={isRTL}  onClick={navigateToInfo}/>
                <Grid
                    container
                    sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr", }}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    {id ?
                        <Grid item xs={12} sm={12} md={12} lg={3} xl={3} display={"flex"} justifyContent={"center"} >
                            <div style={{ width: 200, height: 250,  marginBottom: ((usertype==='customer'||usertype==='driver')?70:0)  }}>
                                {profileImage ? (
                                    <div
                                        onClick={() => fileInputRef.current.click()}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <img
                                            src={URL.createObjectURL(profileImage)}
                                            alt="Profile"
                                            style={{
                                                width: 200,
                                                height: 250,
                                                borderRadius: "19px",
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div
                                        onClick={() => fileInputRef.current.click()}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                width: 200,
                                                height: 250,
                                                display: "flex",
                                                flexDirection: "column",
                                                boxShadow: 3,
                                                border: `2px dashed ${colors.WALLET_CARD_SHADOW}`,
                                                fontSize: 16,
                                                background: "none",
                                                color: "inherit",
                                                fontWeight: "bold",
                                                textAlign:'center'
                                            }}
                                            variant="square"
                                        >
                                            <FileUploadIcon
                                                sx={{
                                                    fontSize: 100,
                                                    marginBottom: 3,
                                                    color: "grey",
                                                }}
                                            />
                                            {<Typography className={classes.typography}>{t("upload_profile_image")}</Typography>}
                                        </Avatar>
                                    </div>
                                )}
                                <input
                                    onChange={(event) => profileImageChange(event)}
                                    multiple={false}
                                    ref={fileInputRef}
                                    type="file"
                                    hidden
                                />
                            </div>
                        </Grid>
                        : null}
                    <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
                        <Grid
                            container
                            spacing={2}
                            sx={{
                                display: "flex",
                                gridTemplateColumns: "50%",
                                rowGap: "20px",
                                marginY: 1,
                                direction: isRTL === "rtl" ? "rtl" : "ltr",
                            }}
                        >
                            {/* CPF / CNPJ — primeiro campo */}
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                    label={t("cpf_cnpj_label")}
                                    id="cpfCnpj"
                                    value={data?.cpfCnpj || ""}
                                    fullWidth
                                    onChange={handleCpfCnpjChange}
                                    onBlur={handleCpfCnpjBlur}
                                    placeholder={t("cpf_cnpj_placeholder")}
                                    helperText={
                                        docStatus === 'filled'         ? t("cpf_autofilled") :
                                        docStatus === 'not_configured' ? t("cpf_not_configured") :
                                        docStatus === 'limit_exceeded' ? t("cpf_limit_exceeded") :
                                        docStatus === 'error'          ? t("cpf_lookup_error") :
                                        docType                        ? t(`doc_type_detected_${docType.toLowerCase()}`) :
                                                                         t("cpf_cnpj_helper")
                                    }
                                    FormHelperTextProps={{
                                        style: {
                                            color: docStatus === 'filled'         ? "#388e3c" :
                                                   docStatus === 'not_configured' ? "#f57c00" :
                                                   docStatus === 'limit_exceeded' ? "#f57c00" :
                                                   docStatus === 'error'          ? "#d32f2f" :
                                                   docType                        ? MAIN_COLOR : "#888",
                                            fontFamily: FONT_FAMILY,
                                            fontSize: "11px",
                                        },
                                    }}
                                    className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {docStatus === 'loading' ? (
                                                    <CircularProgress size={18} thickness={4} style={{ color: MAIN_COLOR }} />
                                                ) : docStatus === 'filled' ? (
                                                    <Tooltip title={t("cpf_autofilled")}>
                                                        <CheckCircleOutlineIcon style={{ color: "#388e3c", fontSize: 20 }} />
                                                    </Tooltip>
                                                ) : null}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                    label={t("rg_placeholder")}
                                    id="rg"
                                    value={data?.rg || ""}
                                    fullWidth
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                     InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                    label={t("firstname")}
                                    id="firstName"
                                    value={data?.firstName || ""}
                                    fullWidth
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                     InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                    label={t("last_name")}
                                    id="lastName"
                                    value={data?.lastName || ""}
                                    fullWidth
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                     InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                    label={t("mobile")}
                                    id="mobile"
                                    value={id ? settings.AllowCriticalEditsAdmin ? data?.mobile || "" : t("hidden_demo") : data?.mobile || ""}
                                    fullWidth
                                    disabled={id ? true : false}
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={6}
                                xl={6}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <TextField
                                     InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                    label={t("email")}
                                    id="email"
                                    value={id ? settings.AllowCriticalEditsAdmin ? data?.email || "" : t("hidden_demo") : data?.email || ""}
                                    fullWidth
                                    disabled={id ? true : false}
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                    InputLabelProps={{ style: { fontFamily: FONT_FAMILY }, shrink: true }}
                                    label={t("birth_date_placeholder")}
                                    id="birthDate"
                                    type="date"
                                    value={data?.birthDate || ""}
                                    fullWidth
                                    onChange={handleInputChange}
                                    className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }}>
                                    <InputLabel id="gender-select-label"
                                        className={isRTL === "rtl" ? classes.right : ""}
                                        sx={{ "&.Mui-focused": { color: MAIN_COLOR } }}>
                                        <Typography className={classes.typography}>{t("gender_placeholder")}</Typography>
                                    </InputLabel>
                                    <Select
                                        labelId="gender-select-label"
                                        id="gender"
                                        value={data?.gender || ""}
                                        label={t("gender_placeholder")}
                                        onChange={(e) => setData({ ...data, gender: e.target.value })}
                                        className={isRTL === "rtl" ? classes.selectField_rtl : classes.selectField}
                                    >
                                        <MenuItem value="">{t("select_gender")}</MenuItem>
                                        <MenuItem value="male">{t("gender_male")}</MenuItem>
                                        <MenuItem value="female">{t("gender_female")}</MenuItem>
                                        <MenuItem value="na">{t("gender_prefer_not_to_say")}</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {usertype === "customer" ?
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <TextField
                                        InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                        label={t("nome_mae")}
                                        id="nomeMae"
                                        value={data?.nomeMae || ""}
                                        fullWidth
                                        onChange={handleInputChange}
                                        className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                    />
                                </Grid>
                                : null}

                            {usertype !== "admin" ?

                                <>

                                    {usertype !== "fleetadmin" ?
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={6}
                                            xl={6}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <TextField
                                                 InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                                label={t("verify_id")}
                                                id="verifyId"
                                                value={data?.verifyId || ""}
                                                fullWidth
                                                onChange={handleInputChange}
                                                className={isRTL === "rtl" ? classes.rootRtl_3 : classes.textField}
                                            />
                                        </Grid>
                                        : null}
                                        {id? 
                                        <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={6}
                                        xl={6}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                        >
                                        <TextField
                                            label={t("referralId")}
                                            id="referralId"
                                            value={data?.referralId ? data?.referralId : t('no_data_available')}
                                            fullWidth
                                            disabled={id ? true : false}
                                            className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                        />
                                        </Grid>
                                        :null}
                                           {id ?
                                           <Grid
                                           item
                                           xs={12}
                                           sm={12}
                                           md={12}
                                           lg={6}
                                           xl={6}
                                           style={{
                                               display: "flex",
                                               justifyContent: "center",
                                               alignItems: "center",
                                           }}
                                           >
                                           <TextField
                                               label={t("signup_via_referral")}
                                               id="signup_via_referral"
                                               value={ settings.AllowCriticalEditsAdmin? signUpReferraldata?signUpReferraldata: t('no_data_available') : t("hidden_demo")}
                                               fullWidth
                                               disabled={id ? true : false}
                                               className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                           />
                                           </Grid>
                                           : null} 
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={6}
                                        xl={6}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }}>
                                            <InputLabel id="demo-simple-select-label" className={isRTL === "rtl" ? classes.right : ""} sx={{ "&.Mui-focused": { color: MAIN_COLOR } }}>
                                                {<Typography className={classes.typography}>{t("approve_status")}</Typography>}
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={data?.approved ? data.approved : approved}
                                                label={t("approve_status")}
                                                onChange={handleChangeApproved}
                                                className={isRTL === "rtl" ? classes.selectField_rtl : classes.selectField}
                                            >
                                                <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} value={true}>
                                                {<Typography className={classes.typography}>{t("approved")}</Typography>}
                                                </MenuItem>
                                                <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} value={false}>
                                                {<Typography className={classes.typography}>{t("not_approved")}</Typography>}
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {auth?.profile?.usertype !== "fleetadmin" && usertype === "driver" ? (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={6}
                                            xl={6}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }}>
                                                <InputLabel id="fleetadmins" className={isRTL === "rtl" ? classes.right_1 : ""} sx={{ "&.Mui-focused": { color: MAIN_COLOR } }}>
                                                {<Typography className={classes.typography}>{t("fleetadmins")}</Typography>}
                                                    </InputLabel>
                                                <Select
                                                    labelId="fleetadmins"
                                                    id="select"
                                                    value={fleetAdminsObj[data?.fleetadmin] || ""}
                                                    label={t("fleetadmins")}
                                                    onChange={handleChangeFleetAdmin}
                                                    className={isRTL === "rtl" ? classes.selectField_rtl : classes.selectField}
                                                >
                                                    {fleetAdmins
                                                        ? fleetAdmins.map((e) => (
                                                            <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} key={e.id} value={fleetAdminsObj[e.id]}>
                                                                {<Typography className={classes.typography}>{e.desc}</Typography>}
                                                            </MenuItem>
                                                        ))
                                                        : null}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    ) : null}
                                </>

                                : null}

                            {/* ── Endereço ─────────────────────────────── */}
                            <Grid item xs={12}>
                                <Divider />
                                <Button
                                    fullWidth
                                    variant="text"
                                    onClick={() => setShowAddress(prev => !prev)}
                                    style={{ justifyContent: 'space-between', marginTop: 8, marginBottom: 4, color: MAIN_COLOR, fontFamily: FONT_FAMILY, textTransform: 'none', fontSize: 15 }}
                                    startIcon={<LocationOnIcon />}
                                    endIcon={showAddress ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                >
                                    {t("address")} {showAddress ? '' : `(${t("optional")})`}
                                </Button>
                            </Grid>

                            <Grid item xs={12} style={{ paddingTop: 0 }}>
                                <Collapse in={showAddress} timeout="auto" unmountOnExit>
                                    <Grid container spacing={2}>
                                        {/* CEP */}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label={t("cep")}
                                                id="cep"
                                                value={data.address?.cep || ''}
                                                fullWidth
                                                onChange={handleCepChange}
                                                placeholder="00000-000"
                                                className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {cepStatus === 'loading' && <CircularProgress size={18} thickness={4} style={{ color: MAIN_COLOR }} />}
                                                            {cepStatus === 'filled'  && <CheckCircleOutlineIcon style={{ color: '#388e3c', fontSize: 20 }} />}
                                                        </InputAdornment>
                                                    )
                                                }}
                                                helperText={cepStatus === 'error' ? t("cep_not_found") : cepStatus === 'filled' ? t("address_auto_filled") : ''}
                                                FormHelperTextProps={{ style: { color: cepStatus === 'error' ? '#d32f2f' : '#388e3c', fontFamily: FONT_FAMILY, fontSize: 11 } }}
                                            />
                                        </Grid>
                                        {/* Logradouro */}
                                        <Grid item xs={12} sm={6} md={8}>
                                            <TextField
                                                label={t("endereco")}
                                                id="endereco"
                                                value={data.address?.endereco || ''}
                                                fullWidth
                                                onChange={handleAddressChange}
                                                className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                            />
                                        </Grid>
                                        {/* Número */}
                                        <Grid item xs={6} sm={3} md={2}>
                                            <TextField
                                                label={t("numero")}
                                                id="numero"
                                                value={data.address?.semNumero ? '' : (data.address?.numero || '')}
                                                fullWidth
                                                disabled={!!data.address?.semNumero}
                                                onChange={handleAddressChange}
                                                className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                            />
                                        </Grid>
                                        {/* Sem número checkbox */}
                                        <Grid item xs={6} sm={3} md={2} style={{ display: 'flex', alignItems: 'center' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={!!data.address?.semNumero}
                                                        onChange={handleSemNumeroChange}
                                                        sx={{ '&.Mui-checked': { color: MAIN_COLOR } }}
                                                    />
                                                }
                                                label={<Typography style={{ fontFamily: FONT_FAMILY, fontSize: 13 }}>{t("sem_numero")}</Typography>}
                                            />
                                        </Grid>
                                        {/* Complemento */}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label={t("complemento")}
                                                id="complemento"
                                                value={data.address?.complemento || ''}
                                                fullWidth
                                                onChange={handleAddressChange}
                                                className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                            />
                                        </Grid>
                                        {/* Bairro */}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label={t("bairro")}
                                                id="bairro"
                                                value={data.address?.bairro || ''}
                                                fullWidth
                                                onChange={handleAddressChange}
                                                className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                            />
                                        </Grid>
                                        {/* Cidade */}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label={t("cidade")}
                                                id="cidade"
                                                value={data.address?.cidade || ''}
                                                fullWidth
                                                onChange={handleAddressChange}
                                                className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                            />
                                        </Grid>
                                        {/* UF */}
                                        <Grid item xs={6} sm={3} md={2}>
                                            <TextField
                                                label={t("uf")}
                                                id="uf"
                                                value={data.address?.uf || ''}
                                                fullWidth
                                                inputProps={{ maxLength: 2, style: { textTransform: 'uppercase' } }}
                                                onChange={(e) => handleAddressChange({ target: { id: 'uf', value: e.target.value.toUpperCase() } })}
                                                className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                            />
                                        </Grid>
                                        {/* Referência */}
                                        <Grid item xs={12} sm={9} md={10}>
                                            <TextField
                                                label={t("referencia")}
                                                id="referencia"
                                                value={data.address?.referencia || ''}
                                                fullWidth
                                                onChange={handleAddressChange}
                                                className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                                                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Collapse>
                            </Grid>
                            {/* ── /Endereço ─────────────────────────────── */}

                            <Grid item xs={12} sm={12} md={12} lg={(isDriverOrFleetAdmin && !isNotAdmin) ? 6 : 12} xl={(isDriverOrFleetAdmin && !isNotAdmin) ? 6 : 12}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Button
                                    style={{
                                        borderRadius: "19px",
                                        backgroundColor: MAIN_COLOR,
                                        minHeight: 50,
                                        textAlign: "center",
                                        width: (((isDriverOrFleetAdmin && !isNotAdmin) || isMidScreen) ? "100%" : "50%")
                                    }}
                                    onClick={id ? handleUpdate : handleAdd}
                                    variant="contained"
                                >
                                    <Typography
                                        style={{
                                            color: "white",
                                            textAlign: "center",
                                            fontSize: 16,
                                            fontFamily: FONT_FAMILY,
                                        }}
                                    >
                                        { id ? t("update") : t("add")}
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Card>
            <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
                {commonAlert.msg}
            </AlertDialog>
        </div>
    );
}

export default EditUser